<template>
  <div>
    <section class="text-center siteWhy section">
      <div class="bg-why"></div>
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-6 ml-md-auto">
            <div class="why-content">
              <h3 class="text-white">Why Choose Cove Orthopaedics For Bunion Treatment?</h3>
              <div class="row">
                <div class="col-6 col-xl-4" v-for="(why, i) in why" :key="i">
                  <div class="why">
                    <img class="img-fluid" :src="why.icon">
                    <h4 v-html="why.name"></h4>
                  </div>
                </div>
              </div>
              <p>Orthopaedic Surgeon Dr Ng specialises in treating foot & ankle conditions. He will be able to provide holistic treatment for any conditions that are bothering you.</p>
              <a href="#enquire-now" class="site-btn site-btn-w">Enquire About a Consultation Today</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<style scoped>
.site-btn-w {
  background-color: white;
  color: black!important;
}
  .siteWhy {
    background: #000000;
    padding: 0;
    position: relative;
  }
  .bg-why {
    background: url('/images/bg-why.jpg');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    width: 100%;
    height: 40vh;
    position: relative;
  }
  .why-content {
    padding: 60px 0 20px;
  }
  .why-content p {
    color: white;
  }
  .why-content .site-btn {
    margin-bottom: 40px;
  }
  .why {
    margin-bottom: 40px;
  }
  .siteWhy h3 {
    margin-bottom: 40px;
  }
  .siteWhy img {
    height: 80px;
  }
  .siteWhy h4 {
    font-size: 16px;
    color: white;
    line-height: 24px;;
  }
  @media (min-width: 576px) {
    .bg-why {
      height: 50vh;
    }
  }
  @media (min-width: 768px) {
    .bg-why {
      width: 50%;
      height: 100%;;
      position: absolute;
      top: 0;
      left: 0;
    }
  }
  @media (min-width: 992px) {
    .why-content  {
      padding: 80px 0 40px 15px;
    }
  }
</style>

<script>
  export default {
    data () {
      return {
        why: [
          {
            icon: '/images/icon-why-01.png',
            name: '<b>Quicker Procedure:</b><br>30 - 45 minutes',
          },
          {
            icon: '/images/icon-why-02.png',
            name: '<b>Smaller Incision:</b><br>Less Than One Centimetre',
          },
          {
            icon: '/images/icon-why-03.png',
            name: '<b>Various Treatments:</b><br>Surgical & Non-Surgical Options Available',
          },
          {
            icon: '/images/icon-why-04.png',
            name: '<b>Lower Risks:</b><br>Less Chance of Infection & Bleeding',
          },
          {
            icon: '/images/icon-why-05.png',
            name: '<b>Reduced Pain:</b><br>Due to Smaller Would & Anaesthesia',
          },
          {
            icon: '/images/icon-why-06.png',
            name: '<b>Faster Recovery:</b><br>Typically Able to Walk the Next Day',
          }
        ]
      }
    }
  }
</script>